"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldFromDate = void 0;
const react_1 = __importDefault(require("react"));
const Date_1 = require("../../../Form/Field/Date");
require("./From.scss");
const className = 'form-field-from-date';
const FormFieldFromDate = (props) => {
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Date_1.FormFieldDate, { ...props }),
        react_1.default.createElement("div", null)));
};
exports.FormFieldFromDate = FormFieldFromDate;
//# sourceMappingURL=From.js.map